import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'

const LanguageTestLoading = () => {
  return (
    <Box className="p-8 text-center w-full py-40 flex flex-col items-center justify-center gap-6">
      <Loader size="lg" />

      <div className="flex flex-col gap-4 mt-12">
        <Typography variant="h2" color={tailwindColors.primary.DEFAULT}>
          Vérification du test en cours...
        </Typography>

        <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
          Veuillez patienter pendant que nous préparons votre test...
        </Typography>
      </div>
    </Box>
  )
}

export default LanguageTestLoading
